import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SignedUrlObject } from '@shared/models/signedUrlObject.model';
import { BaseService } from '@shared/services/base.service';
import { Observable } from 'rxjs';

import {
  MainPageNotificationItem,
  MainPageSaleSummaryItem,
  MembershipSummary,
  SaleDashboardResponse,
  UrgentAnnouncement
} from '../models/main-page.model';
import { ShiftSchedule, ShiftScheduleDocument, ShiftScheduleWeek } from '../models/shift-schedule.model';

@Injectable({
  providedIn: 'root'
})
export class MainPageService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.mainPage;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getNotification(type: string) {
    const url = this.getFullUrlWithStoreNo(this.envService.notification + '/' + type);

    return this.http.get<MainPageNotificationItem>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  getSummary(clientDate = '') {
    const url = this.getFullUrlWithStoreNo(this.envService.summary, { clientDate });

    return this.http.get<MainPageSaleSummaryItem>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  getMembershipSummary() {
    const url = this.getFullUrlWithStoreNo(this.envService.membershipSummary);

    return this.http.get<MembershipSummary>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  getDashboardOverview() {
    const url = this.getFullUrlWithStoreCode(this.envService.dashboardOverview);

    return this.http.get<SaleDashboardResponse>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  getUrgentAnnouncement() {
    const url = this.getFullUrl(this.envService.urgentAnnouncement);
    return this.http.get<UrgentAnnouncement | null>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  printWorkInstruction(saleScheduleDate = ''): Observable<SignedUrlObject> {
    const baseUrl = this.getFullUrlWithStoreNo(this.envService.printDailyWorkInstruction);
    const params = this.getParams({
      saleScheduleDate: saleScheduleDate
    }).toString();
    const url = params ? `${baseUrl}?${params}` : baseUrl;
    return this.http.get<SignedUrlObject>(url, {
      headers: this.loaderHeaders(0),
      observe: 'body'
    });
  }

  getShiftSchedules(): Observable<ShiftSchedule[]> {
    const url = this.getFullUrlWithStoreNo(this.envService.shiftSchedules);

    return this.http.get<ShiftSchedule[]>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  getShiftScheduleDocument(week: ShiftScheduleWeek): Observable<ShiftScheduleDocument> {
    const url = this.getFullUrlWithStoreNo(this.envService.shiftScheduleDocument, { week });

    return this.http.get<ShiftScheduleDocument>(url, {
      headers: this.loaderHeaders(0),
      observe: 'body'
    });
  }
}
